<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 90vw">
      <div class="modal-header">
        <h5 class="modal-title">Bill Payment</h5>
        <button type="button" @click="closepModal">X</button>
      </div>

      <div class="modal-body">
        <div class="container">
          <div class="mt-2 card">
            <PatientInfo v-if="patientId" :patient_id="patientId" :visit_data="visit_data"/>
          </div>
        </div>

        <div class="container mt-4">
          <div class="card p-2">
            <div class="d-flex justify-content-between align-items-center">
              <h5>Total Bill Amount: {{ formatAmount(totalBillAmount) }}</h5>
              <h5>Selected: {{ formatAmount(totalSelectedAmount) }}</h5>
            </div>
          </div>
        </div>

        <div class="container mt-3">
          <div class="card parent-div">
            <div class="table-container">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr style="color: black">
                    <th>Bill Number</th>
                    <th>Service/Item Name</th>
                    <th>Quantity</th>
                    <th>Amount Due</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="bill in bills_data"
                    :key="bill.id"
                    :class="{ 'selected-row': isSelected(bill) }"
                  >
                    <th>
                      <input
                        type="checkbox"
                        :checked="isSelected(bill)"
                        @change="toggleBillSelection(bill)"
                      />
                      {{ bill.id }}
                    </th>
                    <td style="color: black">{{ bill.charge_name }}</td>
                    <td>{{ bill.quantity }}</td>
                    <td>{{ formatAmount(bill.amount_due) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="container mt-4">
          <label>Payment Method <span style="color: red">*</span></label>
          <select v-model="paymentMethod" class="form-control" required>
            <option disabled value="">Select payment method</option>
            <option value="1">Cash</option>
            <option value="3">Mpesa</option>
            <option value="2">Card</option>
            <!-- <option value="4">Invoice</option> -->
          </select>
        </div>

        <div class="mt-4 mb-2 d-flex justify-content-end">
          <button
            class="mycustom-secondary-button"
            @click="paySelected"
            :disabled="selectedBills.length === 0"
          >
            Pay Selected ({{ formatAmount(totalSelectedAmount) }})
          </button>

          <button class="mycustom-success-button" @click="payAll">
            Pay All
          </button>
          <!-- <button class="mycustom-danger-button" @click="sendToInvoice">
            Send to Invoice
          </button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PatientInfo from "../../Patients/components/patient_biodata.vue";
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "cashierBillPop",
  components: { PatientInfo },
  props: {
    patientId: { type: [String, Number], required: true },
    visitId: { type: [String, Number], required: true },
    prescriptionID: { type: [String, Number], required: false },
  },
  data() {
    return {
      bills_data: [],
      visit_data: null,
      selectedBills: [],
      paymentMethod: "",
    };
  },
  computed: {
    totalSelectedAmount() {
      return this.selectedBills.reduce(
        (sum, bill) => sum + Number(bill.amount_due),
        0,
      );
    },
    totalBillAmount() {
      return this.bills_data.reduce(
        (sum, bill) => sum + Number(bill.amount_due),
        0,
      );
    },
  },
  methods: {
    formatAmount(amount) {
      const num = Number(amount);
      if (isNaN(num)) return "0.00";
      return num.toFixed(2);
    },
    isSelected(bill) {
      return this.selectedBills.includes(bill);
    },
    toggleBillSelection(bill) {
      const index = this.selectedBills.indexOf(bill);
      if (index === -1) {
        this.selectedBills.push(bill);
      } else {
        this.selectedBills.splice(index, 1);
      }
    },
    async callData() {
      //
      var vit_id = this.visitId == null ? 0 : this.visitId;
      // alert(vit_id);
      const url = "get_all_visit_bills_at_cashier/" + vit_id;
      const response = await generalApiRequest(
        url,
        "GET",
        { prescription_id: this.prescriptionID },
        1,
      );
      this.bills_data = response.data;
      this.visit_data = response.visit;
    },
    async payAll() {
      if (!this.paymentMethod) {
        alert("Select a payment method first.");
        return;
      }

      // Extract all billing IDs from the bills_data array
      const allBillIds = this.bills_data.map((bill) => bill.id);

      if (allBillIds.length === 0) {
        alert("There are no bills to pay.");
        return;
      }

      console.log("Paying all bills via " + this.paymentMethod);
      console.log(this.bills_data);

      const url = "pay_multiple_bills";
      const body = {
        billing_ids: this.bills_data,
        payment_method: this.paymentMethod,
      };

      console.log(body);

      try {
        await generalApiRequest(url, "POST", body, 1);
        this.closepModal();
        location.reload();
      } catch (error) {
        console.error("Error paying all bills:", error);
        alert("Failed to process payment. Please try again.");
      }
    },
    async paySelected() {
      if (!this.paymentMethod) {
        alert("Select a payment method first.");
        return;
      }
      if (this.selectedBills.length === 0) {
        alert("Select bills to pay.");
        return;
      }
      console.log("Paying selected bills via " + this.paymentMethod);
      console.log(this.selectedBills);

      const url = "pay_multiple_bills";
      const body = {
        billing_ids: this.selectedBills,
        payment_method: this.paymentMethod,
      };
      console.log(body);

      await generalApiRequest(url, "POST", body, 1);
      this.closepModal();
      location.reload();
      // this.bills_data = response.data;
    },
    sendToInvoice() {
      console.log("Sending selected bills to invoice...");
    },
    closepModal() {
      this.$emit("close-bill-modal");
    },
  },
  mounted() {
    this.callData();
  },
};
</script>

<style scoped>
.table-container {
  width: 100%;
}
.table {
  width: 100%;
  table-layout: fixed;
}
.table th,
.table td {
  word-wrap: break-word;
  white-space: normal;
  font-size: 0.85em;
  color: black;
}
.selected-row {
  background-color: #e7f3ff;
}
.mycustom-success-button {
  background: green;
  color: #fff;
  padding: 7px 15px;
  border: none;
  border-radius: 5px;
  margin-left: 10px;
}
.mycustom-secondary-button {
  background: #007bff;
  color: #fff;
  padding: 7px 15px;
  border: none;
  border-radius: 5px;
  margin-left: 10px;
}
.mycustom-danger-button {
  background: #dc3545;
  color: #fff;
  padding: 7px 15px;
  border: none;
  border-radius: 5px;
  margin-left: 10px;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.modal-content {
  background: #fff;
  margin: 30px auto;
  padding: 20px;
  border-radius: 10px;
}
</style>
